import { getContext, getElement, store } from '@wordpress/interactivity';

store(
	'omnipress/query',
	{
		actions: {
			*navigate( event ) {
				const ctx = getContext();
				const { ref } = getElement();

				const queryRef = ref.closest(
					'.wp-block-omnipress-query-loop'
				);

				event.preventDefault();

				const { actions } = yield import(
					'@wordpress/interactivity-router'
				);

				yield actions.navigate( ref.href );
				ctx.url = ref.href;

				// Focus the first anchor of the Query block.
				const firstAnchor = `.wp-block-omnipress-query-template a[href]`;
				queryRef.querySelector( firstAnchor )?.focus();
			},

			*prefetch() {
				const { ref } = getElement();
				console.log( ref, 'ref' );
				const { actions } = yield import(
					'@wordpress/interactivity-router'
				);
				yield actions.prefetch( ref.href );
			},
			isOpen: () => {
				const context = getContext();
				console.log( context );
				context.isOpen = ! context.isOpen;
			},
		},
		callbacks: {
			*prefetch() {
				const { url } = getContext();
				const { ref } = getElement();
				const { actions } = yield import(
					'@wordpress/interactivity-router'
				);
				yield actions.prefetch( ref.href );
			},

			logIsOpen: () => {
				const context = getContext();
				console.log( `Is open: ${ context.isOpen }` );
			},
		},
	},
	{ lock: true }
);
